<template>
  <div class="edit">
    <CloseModalBtn :closeModal="closeModal" />
    <h5>
      {{
        create
          ? localStorage.translations.pages['setting-employee_roles']['dialogs-add_edit'][
              'dobavlenie-dolzhnosti'
            ]
          : localStorage.translations.pages['setting-employee_roles']['dialogs-add_edit'][
              'redaktirovanie-dolzhnosti'
            ]
      }}
    </h5>
    <v-form ref="form" lazy-validation v-model="valid" @submit.prevent="createOrUpdate">
      <label>{{
        localStorage.translations.pages['setting-employee_roles']['dialogs-add_edit-labels'][
          'nazvanie'
        ]
      }}</label>
      <transition name="fade" mode="out-in">
        <v-skeleton-loader
          v-if="!create && !employeeRolesShow"
          width="100%"
          height="86px"
          type="list-item"
        />
        <v-text-field
          v-else
          outlined
          height="48px"
          :placeholder="
            localStorage.translations.pages['setting-employee_roles']['dialogs-add_edit-labels'][
              'nazvanie'
            ]
          "
          v-model="name"
          prepend-inner-icon="person"
          :rules="[inputRules.required, inputRules.max100]"
        />
      </transition>
      <label>{{
        localStorage.translations.pages['setting-employee_roles']['dialogs-add_edit-labels'][
          'number_of_vacancies'
        ]
      }}</label>
      <transition name="fade" mode="out-in">
        <v-skeleton-loader
          v-if="!create && !employeeRolesShow"
          width="100%"
          height="86px"
          type="list-item"
        />
        <v-text-field
          v-else
          outlined
          height="48px"
          :placeholder="
            localStorage.translations.pages['setting-employee_roles']['dialogs-add_edit-labels'][
              'number_of_vacancies'
            ]
          "
          v-model="vacancies_count"
          prepend-inner-icon="person"
          :rules="[inputRules.required]"
          type="Number"
        />
      </transition>

      <div class="container_btn">
        <BaseButton
          type="submit"
          :text="
            localStorage.translations.pages['setting-employee_roles']['dialogs-add_edit-buttons'][
              'sohranit'
            ]
          "
          default_icon="button-save"
        />
      </div>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import CloseModalBtn from 'components/CloseModalBtn'

export default {
  name: 'EmployeeRolesModalForm',
  components: { CloseModalBtn },
  props: ['id', 'dialog', 'closeModal', 'create'],

  data() {
    return {
      valid: true,
      name: '',
      vacancies_count: null,
    }
  },
  created() {
    if (!this.create) {
      this.onEmployeeRolesShow(this.id)
    }
  },

  computed: {
    ...mapGetters(['inputRules']),
    ...mapGetters('employeeRoles', ['employeeRolesShow']),
    apiDomain() {
      return this.$store.state.apiDomain
    },
    SettingEmployeeRolesPage() {
      return this.$route.name === 'SettingEmployeeRoles'
    },
  },
  watch: {
    employeeRolesShow() {
      this.name = this.employeeRolesShow.name
      this.vacancies_count =
        this.employeeRolesShow.vacancies_count > 0 ? this.employeeRolesShow.vacancies_count : null
    },
  },
  methods: {
    ...mapActions('employeeRoles', [
      'onEmployeeRolesShow',
      'onEmployeeRolesCreate',
      'onEmployeeRolesGrid',
      'onEmployeeRolesUpdate',
      'onEmployeeRolesAll',
    ]),
    validate() {
      this.$refs.form.validate()
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0]
    },
    async createOrUpdate() {
      await this.validate()
      if (this.valid === true) {
        if (this.create) {
          let data = {
            name: this.name,
            type: 'role',
            vacancies_count: this.vacancies_count,
          }
          this.onEmployeeRolesCreate(data)
            .then((response) => {
              if (response) {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'uspeshno-dobavlen'
                      ],
                    IsError: false,
                  },

                  { root: true },
                )
                if (this.SettingEmployeeRolesPage) {
                  this.onEmployeeRolesGrid({
                    limit: this.$route.query.limit,
                    page: this.$route.query.page,
                  })
                } else {
                  this.onEmployeeRolesAll()
                }

                this.closeModal()
              }
            })
            .catch((err) => {
              if (err.response.data.name[0]) {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'name_is_already_in_use'
                      ],
                    IsError: true,
                  },
                  { root: true },
                )
              } else {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message: this.localStorage.translations.pages.common.notifications['oshibka'],
                    IsError: true,
                  },
                  { root: true },
                )
              }
            })
        } else {
          let data = {
            id: this.employeeRolesShow.id,
            parent_id: this.employeeRolesShow.parent_id,
            type: this.employeeRolesShow.type ? this.employeeRolesShow.type : 'role',
            name: this.name,
            vacancies_count: this.vacancies_count,
          }
          this.onEmployeeRolesUpdate(data)
            .then((response) => {
              if (response) {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'izmeneniya-uspeshno-sohraneny'
                      ],
                    IsError: false,
                  },

                  { root: true },
                )
                this.onEmployeeRolesGrid({
                  limit: this.$route.query.limit,
                  page: this.$route.query.page,
                })
                this.closeModal()
              }
            })
            .catch((err) => {
              if (err.response.data && err.response.data.name && err.response.data.name[0]) {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'name_is_already_in_use'
                      ],
                    IsError: true,
                  },
                  { root: true },
                )
              } else {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message: this.localStorage.translations.pages.common.notifications['oshibka'],
                    IsError: true,
                  },
                  { root: true },
                )
              }
            })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.edit:deep() {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);
  text-align: center;
  padding: 60px;
  position: relative;
  .close {
    padding: 16px;
  }

  h5 {
    text-align: center;
    margin-bottom: 50px;
  }
  form {
    text-align: left;
    display: grid;
    grid-column-gap: 30px;
    label {
      font-weight: normal;
      font-size: 14px;
      line-height: 26px;
      color: #52525f;
    }

    .v-text-field {
      padding-top: 0px;
      margin-top: 0px;
      fieldset {
        border: 1px solid #b4b4b4;
        border-radius: 4px;
      }
      .theme--light.v-icon {
        color: #b4b4b4;
      }
    }
    .container_btn {
      display: grid;
      justify-content: center;
    }
    .v-input--selection-controls {
      margin-top: 0;
    }
  }
}
</style>
